const moment = require('moment');

export function generateDocDefinition(
  hoursWorkedJobSpecificTotals,
  columnsToShow,
  employeesToShow,
  jobs,
  startDate,
  endDate
) {
  var docDefinition = {
    header: {
      text: `${startDate} - ${endDate}`
    },
    content: [
      {
        columns: generateHeaders(columnsToShow)
      },
      '\n',
      {
        columns: generateTotals(columnsToShow)
      },
      '\n\n',
      {
        columns: [
          { width: '*', text: '' },
          generateTable(
            employeesToShow,
            columnsToShow,
            hoursWorkedJobSpecificTotals,
            jobs
          ),
          { width: '*', text: '' }
        ]
      }
    ],
    styles: {
      employeeName: {
        fontSize: 18,
        alignment: 'center',
        bold: true,
        margin: [0, 0, 0, 0]
      },
      subheader: {
        fontSize: 11,
        bold: true,
        alignment: 'center'
      },
      subheader2: {
        fontSize: 11,
        bold: true,
        color: 'blue',
        alignment: 'center'
      },
      statCalculationsHeader: {
        fontsize: 11,
        bold: true,
        alignment: 'right',
        decoration: 'underline'
      },
      statCalculations: {
        fontsize: 11,
        italics: true,
        alignment: 'right'
      },
      timeCardStyles: {
        fontSize: 7,
        bold: true
      },
      notesStyles: {
        fontSize: 7,
        color: '#ad466c'
      },
      editCommentStyles: {
        fontSize: 7,
        color: '#ff7043'
      },
      tableHeader: {
        fontSize: 10
      }
    }
  };

  return docDefinition;
}

function generateHeaders(columnsToShow) {
  let columns = [];
  columnsToShow.forEach(column => {
    columns.push({ width: '*', text: column.name, style: 'subheader' });
  });
  return columns;
}

function generateTotals(columnsToShow) {
  let columns = [];
  columnsToShow.forEach(column => {
    columns.push({
      width: '*',
      text: column.value.toFixed(2),
      style: 'subheader'
    });
  });
  return columns;
}

function generateTable(
  employeesToShow,
  columnsToShow,
  hoursWorkedJobSpecificTotals,
  jobs
) {
  return {
    width: 'auto',
    table: {
      headerRows: 1,
      body: generateTableBody(
        employeesToShow,
        columnsToShow,
        hoursWorkedJobSpecificTotals,
        jobs
      )
    }
  };
}

function generateTableBody(
  employeesToShow,
  columnsToShow,
  hoursWorkedJobSpecificTotals,
  jobs
) {
  //add empty slot to start of columns
  employeesToShow.sort((a, b) =>
    a.employee.name.localeCompare(b.employee.name)
  );

  let columns = [];
  columnsToShow.forEach(column => {
    columns.push(column.name);
  });
  columns.unshift('Job');
  columns.unshift('Employee');
  let body = [];
  let hasTravelTime =
    columnsToShow.findIndex(x => x.dataName === 'travelTimeTotal') === -1
      ? false
      : true;
  let hasOnCallTime =
    columnsToShow.findIndex(x => x.dataName === 'onCallHoursTotal') === -1
      ? false
      : true;
  let hasStatTime =
    columnsToShow.findIndex(x => x.dataName === 'statTotal') === -1
      ? false
      : true;
  body.push(columns);
  employeesToShow.forEach(employee => {
    let totals = [
      employee.employee.name,
      '',
      employee.regularTotal.toFixed(2),
      employee.otTotal.toFixed(2)
    ];
    if (hasTravelTime) {
      totals.push(employee.travelTimeTotal.toFixed(2));
    }
    if (hasOnCallTime) {
      totals.push(employee.onCallHoursTotal.toFixed(2));
    }
    if (hasStatTime) {
      totals.push(employee.statTotal.toFixed(2));
    }
    totals.push(employee.total.toFixed(2));

    body.push(totals);
    let jobsData = [];
    let employeesJobSpecificHours = hoursWorkedJobSpecificTotals.find(
      x => x.employee.id === employee.employee.id
    );
    if (employeesJobSpecificHours) {
      Object.keys(employeesJobSpecificHours.regular).forEach(job => {
        jobsData.push(job);
      });
      Object.keys(employeesJobSpecificHours.ot).forEach(job => {
        if (!jobsData.includes(job)) {
          jobsData.push(job);
        }
      });

      jobsData.forEach(job => {
        let jobSpecificTotals = [
          '',
          getJobName(job, jobs),
          employeesJobSpecificHours.regular[`${job}`]
            ? employeesJobSpecificHours.regular[`${job}`].toFixed(2)
            : 0.0,
          employeesJobSpecificHours.ot[`${job}`]
            ? employeesJobSpecificHours.ot[`${job}`].toFixed(2)
            : 0.0,
          ''
        ];
        if (hasTravelTime) {
          jobSpecificTotals.push('');
        }
        if (hasOnCallTime) {
          jobSpecificTotals.push('');
        }
        if (hasStatTime) {
          jobSpecificTotals.push('');
        }

        body.push(jobSpecificTotals);
      });
    }
  });

  return body;
}

function getJobName(id, jobs) {
  if (id && id !== 'default') {
    let job = jobs.find(x => x.id === id);
    return job.description;
  }
  return null;
}
